import React from "react";
import { View, TouchableNativeFeedback } from "react-native";
import Text from "./CustomText";

const Button = ({
  contentContainerStyle = {},
  btnText = "",
  style = {},
  onPress = () => {},
  IconLeft = null,
}) => {
  return (
    <View style={contentContainerStyle}>
      <TouchableNativeFeedback onPress={onPress}>
        <View style={style}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {IconLeft ? <IconLeft /> : null}
            <Text
              style={{
                fontFamily: "NotoSansDevanagari-SemiBold",
                color: "white",
                marginLeft: IconLeft ? 7 : 0,
              }}
            >
              {btnText}
            </Text>
          </View>
        </View>
      </TouchableNativeFeedback>
    </View>
  );
};

export default Button;
